"use client";
import { useClientConfigProvider } from "../config/client-config-provider";

export default function SpinnerLoader() {
  const { getImagePath } = useClientConfigProvider();
  return (
    <div
      className="spinner-small"
      style={{
        background: `url(${getImagePath("progress-c-icon.png")}) no-repeat`,
        backgroundSize: "contain",
      }}
    />
  );
}
